import React, { useState, useEffect } from 'react'
import './index.css'
import COLORS from '../../colors'
import { Button } from '@material-ui/core'
import { ReactComponent as Alert } from '../../assets/alert.svg'
import { ReactComponent as Close } from '../../assets/close_gray.svg'
import { isMobile } from 'react-device-detect'

const ModalLogoutAlert = ({ popup, onClose }) => {
		const [ width, setWidth ] = useState(window.innerWidth)
		const [ height, setHeight ] = useState(window.innerHeight)

		useEffect(()=>
		{
			function setInnerDimension()
			{
					setWidth(window.innerWidth)
					setHeight(window.innerHeight)	 	 
			}
			window.addEventListener('resize', setInnerDimension, false)
			return () => window.removeEventListener('resize', setInnerDimension, false)
		},[])

	if (!popup) return null
    return (
    			<div className="modal-logout" >
					<div className="overlay-modal-logout" />
					<div className="modal-body-logout" style={{width:!isMobile?'25rem':'90%', height:!isMobile?(height>820?'18rem':'45%'):'50%'}}>
						<div className="modal-logout-alert">
							<div className="modal-logout-alert-title">Tvoja sesija je istekla!</div>
							<Close className="btn-close-btn" onClick={() => onClose()}/>
						</div>
						<Alert />
						<div className="modal-logout-text">Molimo te da se ponovno prijaviš na KEKS POS!</div>
						<Button size="large" 
                 			variant="contained"
                 			style={{ width:'90%', 
                             	color:"#fff", 
                             	fontWeight: 'bold', 
                             	backgroundColor:COLORS.blue, 
                     		 	textTransform: 'none',
							 	margin:'1rem',
								"&:hover": {
									backgroundColor: COLORS.blue
							  	} 
                       			}} 
							onClick={() => onClose()}
						>OK, ZATVORI</Button> 	
					</div>
    			</div>
	)
}

export default ModalLogoutAlert
